import { Component, OnInit } from '@angular/core';
import { CategoryService } from 'src/app/services/category.service';
import { Category } from 'src/app/models/category';
import { forkJoin, BehaviorSubject } from 'rxjs';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course';
import { SupporterService } from 'src/app/services/supporter.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { RoleFilters } from 'src/app/models/roleFilters';
import { FilterService } from 'src/app/services/filter.service';

import { RoleStreamFilters } from 'src/app/models/roleStreamFilters';
import { FilterStreamService } from 'src/app/services/filterStream.service';

import { StreamService } from 'src/app/services/stream.service';
import { BlogService } from 'src/app/services/blog.service';
import { BlogPost } from 'src/app/models/blogpost';
import { ProgrammeService } from 'src/app/services/programme.service';
import { TestimonialService } from 'src/app/services/testimonial.service';
import { SlidesService } from 'src/app/services/slides.service';
import { Slide } from 'src/app/models/slide';
import { environment } from '../../../environments/environment';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  public loadingData=true;
  public categories: Category[];
  public featuredCourses: Course[];
  public currentlyWatching: Course[];
  public supporters: any[];
  public catCourses: any;
  public streams: any[];
  public loggedIn:boolean=false;
  public image:string='/assets/imgs/watch-and-learn-cat.jpg';
  public title:string='Learn from our team of experienced experts';
  public blurb:string='';
  public buttonText:string='Find a new CPD video';
  public buttonLink:string='/categories';
  public lunchAndLearn:Course[];
  public roleFilters: RoleFilters;
  public roleStreamFilters: RoleStreamFilters;
  public blogPosts: BlogPost[];
  public myProgrammes:any[];
  public currentTrainingProgramme:number;
  public activeProgrammeData:any;
  public watchlist:Course[];
  public testimonials=[];
  public limited:boolean=false;
  public practiceDisabled:boolean=false;
  // TimeZone related configuration
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;
  public AucklandTimeZone:boolean = false;
  public EUTimeZone:boolean = false;
  public CanadaTimeZone:boolean = false;

  public slideConfig = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    'arrows': true,
    autoplay: true
  };
  public slideConfig2 = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    'arrows': true,
    autoplay: true,
    'responsive': [
      {'breakpoint': 1299, 'settings': { 'slidesToShow': 1, 'slidesToScroll': 1, 'arrows': true} },
      {'breakpoint': 900, 'settings': { 'slidesToShow': 1, 'slidesToScroll': 1, 'arrows': true} },
      {'breakpoint': 600, 'settings': { 'slidesToShow': 1, 'slidesToScroll': 1, 'arrows': true} },
    ]};
  public popularSlideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 4,
    'arrows': true,
    autoplay: false,
    'responsive': [
      {'breakpoint': 1299, 'settings': { 'slidesToShow': 3, 'slidesToScroll': 3, 'arrows': true} },
      {'breakpoint': 900, 'settings': { 'slidesToShow': 2, 'slidesToScroll': 2, 'arrows': true} },
      {'breakpoint': 600, 'settings': { 'slidesToShow': 1, 'slidesToScroll': 1, 'arrows': true} },
    ]};

  public supporterSlideConfig = {
    "slidesToShow": 8,
    "slidesToScroll": 8,
    'arrows': true,
    autoplay: false,
    'responsive': [
      {'breakpoint': 1299, 'settings': { 'slidesToShow': 6, 'slidesToScroll': 6, 'arrows': true} },
      {'breakpoint': 900, 'settings': { 'slidesToShow': 4, 'slidesToScroll': 4, 'arrows': true} },
      {'breakpoint': 600, 'settings': { 'slidesToShow': 2, 'slidesToScroll': 2, 'arrows': true} },
    ]};

  public reviewSlideConfig = {
    "slidesToShow": 3,
    "slidesToScroll": 3,
    'arrows': true,
    autoplay: false,
    'responsive': [
      {'breakpoint': 1299, 'settings': { 'slidesToShow': 3, 'slidesToScroll': 3} },
      {'breakpoint': 900, 'settings': { 'slidesToShow': 2, 'slidesToScroll': 2} },
      {'breakpoint': 600, 'settings': { 'slidesToShow': 1, 'slidesToScroll': 1} },
    ]};
  slides = [
    {img: "/assets/imgs/livebanner2a.jpg", link: '/stream/3015'},
    {img: "/assets/imgs/banner1.jpg", link: '/register'},
    {img: "/assets/imgs/banner2.jpg", link: '/categories'},
    {img: "/assets/imgs/banner3.jpg", link: '/tutors'}
  ];
  public homeSlides:Slide[];
  public imagePathBase:string='';
  constructor(
    private categoryService: CategoryService,
    private courseService: CourseService,
    private _supporter: SupporterService,
    private _auth: AuthenticationService,
    private _streams: StreamService,
    private _filter: FilterService,
    private _filterStream: FilterStreamService,
    private _blog: BlogService,
    private _programmes: ProgrammeService,
    private _testimonials: TestimonialService,
    private _slides: SlidesService,
    private _subs: SubscriptionService,
    private timezoneService: TimeZoneService
  ) {
    this.imagePathBase=environment.apiEndpoint;
    if(localStorage.getItem('limitedPractice') && localStorage.getItem('limitedPractice') == '1') this.limited=true;
    this._auth.loggedIn.subscribe(res=>{
      this.loggedIn=res;

    });

    this._filter.roleFiltersSubject.subscribe(
      (data:RoleFilters) => {
        this.roleFilters=data;
        this.categoryService.getCategoryCourses(17, this.roleFilters).subscribe(
          data => {
            this.lunchAndLearn=data.slice(0,8);
          }
        );
      }
    );

    let acc=this._auth.getAccount();
    if(acc.practice_id>0 && acc.practice_status<1){
      this._subs.getUserSubscriptions().subscribe(
        res=>{
          let flag=true;
          if(res)
          {
            res.forEach(sub=>{
              if(
                sub.status=='active'
              )
              {
                flag=false;
              }
            });
          }
          this.practiceDisabled=flag;
        }
      );
    }
  }

  private structureMyProgrammes(){
    this.myProgrammes.forEach((data, index) => {
      data.courses.forEach((data2, index2) => {
        this.myProgrammes[index].courses[index2]=data2.course;
      })
    });
  }

  public updateActiveProgramme(id:number){
    this.setActiveProgrammeData(id);
    this.currentTrainingProgramme=id;
  }

  public setActiveProgrammeData(id:number){
    this.myProgrammes.forEach(data => {
      if(data.id==id) this.activeProgrammeData=data;
    });
  }

  orderCurrentlyWatching(){
    let cw=[];
    if(this.currentlyWatching.length){
      this.currentlyWatching.sort((a,b) =>
        (b.lessons[0].meta[0] ? Date.parse(b.lessons[0].meta[0].updated_at) : 0) - (a.lessons[0].meta[0] ? Date.parse(a.lessons[0].meta[0].updated_at) : 0)
      );
    }
  }

  ngOnInit() {
    // Check the timeZone
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    // if(!this.loggedIn){
      this._slides.getSlides().subscribe(
        res=>{
          this.homeSlides=res;
        }
      );
    // }
    if(this.loggedIn) {
      forkJoin(

        // this._programmes.getMyProgrammes(true),
        this.courseService.getCurrentlyWatching(8),
        this.courseService.getuserWatchlist(8),
        this._streams.getPopularStreamsWithMeta(),
        this.categoryService.getCategoryCourses(17, this.roleFilters, this.loggedIn)
      ).subscribe(data=>{
        // this.myProgrammes=data[0];
        // this.structureMyProgrammes();
        // if(this.myProgrammes[0]) this.currentTrainingProgramme=this.myProgrammes[0].id || 0;
        // this.setActiveProgrammeData(this.currentTrainingProgramme);
        this.currentlyWatching=data[0];
        this.orderCurrentlyWatching();
        this.watchlist=data[1];
        this.streams=data[2];
        this.lunchAndLearn=data[3].slice(0,8);
        this.streamCPD();
      });
    }
    forkJoin(

      this.categoryService.getCategories(),
      //this.courseService.getRandom(),
      this.courseService.featured(this.loggedIn),
      this._supporter.getSupportersRnd(),
      this._streams.getPopularStreams(),

      this._testimonials.getTestimonials(3),
      this._blog.getLatest(8),
    ).subscribe(data=>{
      this.categories = data[0];
      //this.catCourses = data[1];
      this.featuredCourses = this.shuffle(data[1]);
      this.supporters=data[2];
      // if(!this.loggedIn){
        this.streams=data[3];
        this.streamCPD();
      // }

      this.testimonials=data[4];
      this.blogPosts=data[5];
      this.loadingData=false;
    })
  }

  streamCPD(){
    this.streams.forEach((stream, index) => {
      this.streams[index].minutes=0;
      stream.active_courses.forEach(course => {
        this.streams[index].minutes+=course.course.points;
      });
    });
  }

  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    while (0 !== currentIndex) {

      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }
}
